module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal-alert/modal-alert.component.css
// module id = ./src/app/shared/modal/modal-alert/modal-alert.component.css
// module chunks = main